import { Form, Input, message } from "antd";
import FileInput from "./FileInput";

export default function AudioInput({ form, prefix, fullPrefix }: any) {
    const onFileChange = (file: any) => {
        if (!file) return;
        setAudioDuration(file.url);
    }

    const setAudioDuration = (url: any) => {
        const audioElement = new Audio(url);
        audioElement.addEventListener("loadedmetadata", (e) => {
            const time = Math.floor(audioElement.duration) || 0;
            form.setFieldValue([...fullPrefix, 'audioDuration'], time)
        })
        audioElement.addEventListener("error", (e) => {
            message.error('获取音频时长失败');
        })
    }

    const InputBody = () => <>
        <FileInput form={form} labelPre="音频" prefix={prefix} fullPrefix={fullPrefix} rules={[{ required: true, message: '不能为空' }]}
            type="audio" accept='audio/*' namePre="audio" onChange={onFileChange} />
        <Form.Item label={`音频时长（秒）`} name={[...prefix, 'audioDuration']} rules={[{ required: true, message: '不能为空' }]}>
            <Input placeholder="请输入音频时长" />
        </Form.Item>
    </>

    return <InputBody />
}